import { toast } from "sonner";

/**
 * Telling a cancelled request apart from a failed one.
 *
 * Apollo rejects an in-flight query with an AbortError when its component is torn
 * down — and a page that swaps itself for a skeleton on every refetch tears down
 * its children mid-request. The write that triggered the refetch already
 * succeeded, so reporting the abort put "The operation was aborted." on screen
 * next to "Enrolled 3 of 3."
 *
 * Fixing the teardown is the real fix (keep rendering while a refetch is in
 * flight); this is the backstop for the cases that remain legitimate — navigating
 * away, or collapsing a panel, while something is still finishing.
 */
export const isTeardownError = (error: unknown): boolean => (error as { name?: string } | null)?.name === "AbortError";

/** Reports a failure unless it was just a cancelled request. */
export const reportQueryFailure = (error: unknown, fallback: string): void => {
    if (isTeardownError(error)) return;
    toast.error(error instanceof Error ? error.message : fallback);
};
